import React, { useEffect, useState } from "react";

const AutoSizer = ({ children, height }) => {
  const wrapperRef = React.useRef(null);
  const frameRef = React.useRef(null);

  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const updateDimensions = () => {
      if (!wrapperRef.current) return;
      const { width, height } = wrapperRef.current.getBoundingClientRect();
      setDimensions((prev) => {
        if (prev.width === width && prev.height === height) {
          return prev;
        }
        return { width, height };
      });
    };

    const resizeObserver = new ResizeObserver(() => {
      if (frameRef.current) {
        cancelAnimationFrame(frameRef.current);
      }
      frameRef.current = requestAnimationFrame(updateDimensions);
    });

    if (wrapperRef.current) {
      resizeObserver.observe(wrapperRef.current);
      updateDimensions();
    }

    return () => {
      if (frameRef.current) {
        cancelAnimationFrame(frameRef.current);
      }
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <div
      ref={wrapperRef}
      style={{
        display: "inline-block",
        position: "relative",
        width: "100%",
        ...(height ? { height: "100%" } : {}),
      }}
    >
      {children(dimensions)}
    </div>
  );
};

export default AutoSizer;
